export default __webpack_public_path__ + "static/media/frame3.b6b9adc5.png";